import { objectToQueryString } from 'Utils/utils'
import AxiosClient from './api'
import END_POINT from './constants'

export function getUserList(payload) {
  const params = objectToQueryString(payload)
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.USER_LIST.GET}${params}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function blockOrActiveUser(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.USER_LIST.BLOCK_OR_ACTIVE}`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getInfoUserAndPortfolio({ userId, portfolioId }) {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.USER_LIST.GET_INFO}/${userId}/${portfolioId}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}
